import React from 'react';

/** iPhone-style frame so the mockup reads as the mobile app it will become. */
export function PhoneFrame({
  children
}: {
  children?: React.ReactNode;
}) {
  return <div className="relative h-[820px] w-[392px] shrink-0 overflow-hidden rounded-[54px] border-[10px] border-[#1A1F1D] bg-linen shadow-[0_30px_80px_rgba(0,0,0,0.45)]" data-id="element-847">
      {/* status bar */}
      <div className="pointer-events-none absolute left-0 right-0 top-0 z-50 flex items-center justify-between px-8 pt-4" data-id="element-848">
        <span className="text-[14px] font-bold text-ink" data-id="element-849">9:41</span>
        {/* dynamic island */}
        <div className="absolute left-1/2 top-3 h-[26px] w-[100px] -translate-x-1/2 rounded-full bg-[#1A1F1D]" data-id="element-850" />
        <span className="flex items-center gap-1" data-id="element-851">
          {/* signal */}
          <svg width="16" height="11" viewBox="0 0 16 11" fill="currentColor" className="text-ink" data-id="element-852">
            <rect x="0" y="7" width="3" height="4" rx="1" data-id="element-853" />
            <rect x="4.5" y="4.5" width="3" height="6.5" rx="1" data-id="element-854" />
            <rect x="9" y="2" width="3" height="9" rx="1" data-id="element-855" />
            <rect x="13" y="0" width="3" height="11" rx="1" opacity="0.35" data-id="element-856" />
          </svg>
          {/* battery */}
          <svg width="25" height="12" viewBox="0 0 25 12" className="text-ink" data-id="element-857">
            <rect x="0.5" y="0.5" width="21" height="11" rx="3.5" stroke="currentColor" opacity="0.4" fill="none" data-id="element-858" />
            <rect x="2" y="2" width="14" height="8" rx="2" fill="currentColor" data-id="element-859" />
            <path d="M23 4v4c1-.3 1.5-1 1.5-2s-.5-1.7-1.5-2z" fill="currentColor" opacity="0.4" data-id="element-860" />
          </svg>
        </span>
      </div>

      {/* app content */}
      <div className="relative h-full w-full pt-12" data-id="element-861">{children}</div>

      {/* home indicator */}
      <div className="pointer-events-none absolute bottom-2 left-1/2 z-50 h-[5px] w-[134px] -translate-x-1/2 rounded-full bg-ink opacity-80" data-id="element-862" />
    </div>;
}